import { IStoreState } from "./store";

export const getUserPassengers = (state: IStoreState) =>
  state.rootReducer.userPassengers;

export const getUserPassengerCallState = (state: IStoreState) =>
  state.rootReducer.userPassengerCallState;

export const getUserSelectedTravelerId = (state: IStoreState) =>
  state.rootReducer.userSelectedTravelerId;
